import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f917d2da")

_pushScopeId("data-v-f917d2da")
const _hoisted_1 = { class: "performanceOverview" }
const _hoisted_2 = { class: "performanceDataDetails" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("最近测试记录    ")
], -1)
const _hoisted_4 = { class: "spacName2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("全部清空")
const _hoisted_6 = {
  key: 1,
  style: {"color":"#c0c4cc"}
}
const _hoisted_7 = {
  key: 1,
  style: {"color":"#c0c4cc"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createVNode("div", _hoisted_4, [
                    _createVNode(_component_el_card, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_form, {
                          class: "spacForm",
                          size: "mini",
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "选择场景" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.selected_table_scene,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected_table_scene = $event)),
                                  placeholder: "请选择场景",
                                  clearable: "",
                                  filterable: "",
                                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectTableChange('Search')))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.scene_id,
                                        label: item.chinese,
                                        value: item.scene_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择机型" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.selected_table_device,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selected_table_device = $event)),
                                  placeholder: "请选择机型",
                                  clearable: "",
                                  filterable: "",
                                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectTableChange('Search')))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.device_id,
                                        label: item.device_name,
                                        value: item.device_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onTableClear()))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_el_table, {
                          onSelectAll: _ctx.handleSelect,
                          data: _ctx.get_all_performance,
                          ref: "dataTable",
                          "header-cell-class-name": "tabelHeader"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              index: _ctx.indexMethod(0),
                              type: "index",
                              label: "序号",
                              width: "60"
                            }, null, 8, ["index"]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PerfFields, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                key: item.label,
                                index: index,
                                width: item.width,
                                label: item.label,
                                prop: item.prop,
                                title: item.prop
                              }, null, 8, ["index", "width", "label", "prop", "title"]))
                            }), 128)),
                            _createVNode(_component_el_table_column, {
                              label: "状态",
                              width: "150"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  style: 'color:' + _ctx.statusShow(scope.row.status)[1]
                                }, _toDisplayString(_ctx.statusShow(scope.row.status)[0]), 5)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "操作",
                              width: "100"
                            }, {
                              default: _withId((scope) => [
                                (scope.row.status == 4)
                                  ? (_openBlock(), _createBlock("span", {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.retry(scope.row.id)),
                                      style: {"cursor":"pointer","color":"#61c3e4"}
                                    }, "重试", 8, ["onClick"]))
                                  : (_openBlock(), _createBlock("span", _hoisted_6, "重试"))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "有效",
                              width: "60"
                            }, {
                              default: _withId((scope) => [
                                _createVNode(_component_el_checkbox, {
                                  onChange: ($event: any) => (_ctx.checkChange(scope.row)),
                                  modelValue: scope.row.valid,
                                  "onUpdate:modelValue": ($event: any) => (scope.row.valid = $event)
                                }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "详情",
                              width: "60"
                            }, {
                              default: _withId((scope) => [
                                (_ctx.statusShow(scope.row.status)[2])
                                  ? (_openBlock(), _createBlock("span", {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.see(scope.row)),
                                      style: {"cursor":"pointer","color":"#61c3e4"}
                                    }, "查看", 8, ["onClick"]))
                                  : (_openBlock(), _createBlock("span", _hoisted_7, "查看"))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onSelectAll", "data"]), [
                          [_directive_loading, _ctx.loading]
                        ]),
                        _createVNode(_component_el_form, {
                          inline: true,
                          size: "mini",
                          class: "pagingStyle"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "每页" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.record,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.record = $event)),
                                  style: {"width":"50px"},
                                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectTableChange('paging')))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "条记录" }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  onCurrentChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectTableChange('paging'))),
                                  currentPage: _ctx.current_page,
                                  "onUpdate:currentPage": _cache[9] || (_cache[9] = ($event: any) => (_ctx.current_page = $event)),
                                  "page-size": _ctx.record,
                                  layout: "total, prev, pager, next, jumper",
                                  total: _ctx.readPerformancePageList.count
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})